const T_PREFIX = "auth";

export const loginPopupTrns = {
  title: `${T_PREFIX}.login-popup.title`,
  loginButton: `${T_PREFIX}.login-popup.login-btn`,
  googleLoginButton: `${T_PREFIX}.login-popup.google-login-btn`,
  resetPasswordButton: `${T_PREFIX}.login-popup.reset-password-btn`,
};
